import { render } from "./Speciessearch.vue?vue&type=template&id=2d72235c"
import script from "./Speciessearch.vue?vue&type=script&lang=js"
export * from "./Speciessearch.vue?vue&type=script&lang=js"

import "./Speciessearch.vue?vue&type=style&index=0&id=2d72235c&lang=css"

import exportComponent from "/builds/dlr-pt/rote-liste-zentrum/prj-flechten_app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__